<template>
  <div class="home">
    <v-carousel
      v-touch="swipeCarousel"
      cycle
      :height="$store.state.mobile ? 270 : 755"
      hide-delimiters
      show-arrows-on-hover
    >
      <v-carousel-item
        v-for="item in bannerList.data"
        :key="item.ad_id"
        :src="item.ad_code"
        :to="item.ad_link ? item.ad_link: '/'"
        :contain="$store.state.mobile ? false : true"
      />
    </v-carousel>
    <v-container>
      <div class="display-4 text-uppercase font-medium">
        <template v-if="$store.getters.languageGetter === '1'">
          فئة المنتج
        </template>
        <template v-else>
          Product category
        </template>
      </div>
      <div class="position-relative">
        <v-btn
          icon
          class="btn-prev"
          :style="$store.state.mobile ? 'left:15px;top:50%;margin-top:-15px' : 'left:15px;top:50%;margin-top:-75px'"
          color="white"
          @click="cateCarousel -= 1"
        >
          <v-icon>mdi-chevron-left</v-icon>
        </v-btn>
        <v-btn
          icon
          class="btn-next"
          :style="$store.state.mobile ? 'right:15px;top:50%;margin-top:-15px' : 'right:15px;top:50%;margin-top:-75px'"
          color="white"
          @click="cateCarousel += 1"
        >
          <v-icon>mdi-chevron-right</v-icon>
        </v-btn>
        <v-carousel
          v-model="cateCarousel"
          v-touch="cateCarousel"
          light
          hide-delimiters
          :show-arrows="false"
          height="auto"
        >
          <v-carousel-item
            v-for="(arr, i) in categoriesLocal"
            :key="i"
          >
            <v-row
              align="stretch"
              :dense="$store.state.mobile"
              :class="$store.state.mobile ? '' : 'mb-4'"
            >
              <v-col
                v-for="item in arr"
                :key="item.id"
                :cols="$store.state.mobile ? 6 : 3"
              >
                <v-card
                  elevation="0"
                  class="rounded-0 fill-height"
                >
                  <v-img
                    :src="item.image ? item.image + '?x-oss-process=image/resize,m_mfit,w_375,h_375' : require('@/assets/imgWaiting.png')"
                    class="cursor-pointer grey lighten-5"
                    @click="navigateToGoodsList(item)"
                  >
                    <template v-slot:placeholder>
                      <v-row
                        class="fill-height ma-0"
                        align="center"
                        justify="center"
                      >
                        <v-progress-circular
                          indeterminate
                          color="grey"
                        />
                      </v-row>
                    </template>
                  </v-img>
                  <div class="py-2">
                    <div
                      class="font-medium cursor-pointer"
                      :class="$store.state.mobile ? 'text-center font-weight-bold text-h5 line-height-sm' : 'text-h3'"
                      @click="navigateToGoodsList(item)"
                    >
                      {{ $store.getters.languageGetter === '1' ? item.dnames : item.dnamesEn }}
                    </div>
                    <div
                      v-if="!$store.state.mobile"
                      class="d-flex flex-wrap"
                    >
                      <div
                        v-for="(subitem, subi) in item.son"
                        :key="subitem.id"
                        class="mb-1"
                      >
                        <div
                          class="cursor-pointer grey--text text--darken-2"
                          @click="navigateToGoodsList(subitem)"
                        >
                          {{ $store.getters.languageGetter === '1' ? subitem.dnames : subitem.dnamesEn }}<span
                            v-if="subi < item.son.length - 1"
                            style="margin-right:2px;margin-left:2px"
                          >/</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </v-card>
              </v-col>
            </v-row>
          </v-carousel-item>
        </v-carousel>
      </div>
    </v-container>
    <div style="background-color:#111f5e">
      <v-container
        fill-height
        class="py-12 align-stretch about-us"
        :style="$store.state.mobile ? 'background-position: center center;' : $store.getters.languageGetter === '1' ? 'background-position: right center;' : 'background-position: left center;'"
      >
        <v-row
          align="center"
          style="min-height:784px"
        >
          <v-col
            :cols="$store.state.mobile ? 12 :7"
            :offset="$store.state.mobile ? 0 : 5"
          >
            <div class="white fill-height pa-12">
              <div :class="$store.state.mobile ? '' : 'px-6'">
                <div
                  class="font-medium text-uppercase mb-8"
                  style="font-size:48px"
                >
                  <template v-if="$store.getters.languageGetter === '1'">
                    ملف الشركة
                  </template>
                  <template v-else>
                    Company profile
                  </template>
                </div>
                <div>
                  <span class="font-medium text-uppercase">
                    {{ $store.getters.languageGetter === '1' ? $store.state.webConfig.companyName : $store.state.webConfig.companyNameEn }}
                  </span>
                  <span v-html="$store.getters.languageGetter === '1' ? $store.state.webConfig.aboutSummary : $store.state.webConfig.aboutSummaryEn" />
                </div>
                <v-btn
                  color="dark"
                  outlined
                  class="text-uppercase px-12 mt-10"
                  x-large
                  tile
                  :to="{name: 'AboutUs'}"
                >
                  <template v-if="$store.getters.languageGetter === '1'">
                    شاهد المزيد
                  </template>
                  <template v-else>
                    See More
                  </template>
                </v-btn>
              </div>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </div>
    <v-container>
      <v-row class="text-center">
        <v-col
          cols="12"
          class="py-0 text-uppercase"
          :class="$store.state.mobile ? '' : 'mt-4'"
        >
          <v-row
            no-gutters
            align="center"
          >
            <v-col
              cols="auto"
              class="text-h1 font-medium"
            >
              <template v-if="$store.getters.languageGetter === '1'">
                منتج جديد
              </template>
              <template v-else>
                New Arrivals
              </template>
            </v-col>
            <v-spacer />
            <v-col cols="auto">
              <router-link
                :to="{name: 'GoodsList', query: {type: '2', target: 'newArrivals', p: 1}}"
                class="d-inline-flex align-center text-h6"
              >
                <template v-if="$store.getters.languageGetter === '1'">
                  شاهد المزيد
                </template>
                <template v-else>
                  See More
                </template> <v-icon small>
                  mdi-chevron-right
                </v-icon>
              </router-link>
            </v-col>
          </v-row>
        </v-col>
        <v-col
          v-for="item in tagGoods.newArrivals.data.slice(0,8)"
          :key="item.id"
          :cols="$store.state.mobile ? 6 : 3"
        >
          <v-card
            :outlined="$store.state.mobile"
            elevation="0"
            tile
          >
            <router-link
              :to="{name: 'GoodsDetail', params: {id: item.id}}"
            >
              <v-img
                aspect-ratio="1"
                contain
                :src="item.image + '?x-oss-process=image/resize,m_mfit,w_375,h_375'"
                class="grey lighten-5"
              >
                <template v-slot:placeholder>
                  <v-row
                    class="fill-height ma-0"
                    align="center"
                    justify="center"
                  >
                    <v-progress-circular
                      indeterminate
                      color="grey"
                    />
                  </v-row>
                </template>
              </v-img>
            </router-link>
          </v-card>
          <div class="px-4">
            <div class="text-h6 mt-3 text-truncate">
              <router-link
                :to="{name: 'GoodsDetail', params: {id: item.id}}"
              >
                {{ $store.getters.languageGetter === '1' ? item.dnames : item.dnamesEn }}
              </router-link>
            </div>
            <div
              v-if="$store.state.usedCountry"
              class="black--text d-flex align-center justify-center"
            >
              <span
                class="text-h4 me-2"
              >{{ $store.getters.countryGetter.currency }}{{ (priceRate(item) * $store.getters.rebateGetter / 100).toFixed(2) }}</span>
              <span :class="$store.getters.rebateGetter < 100 ? 'text-decoration-line-through grey--text' : 'd-none'">{{ $store.getters.countryGetter.currency }}{{ priceRate(item).toFixed(2) }}</span>
            </div>
          </div>
        </v-col>
      </v-row>
    </v-container>
    <div class="grey lighten-5 pb-8">
      <v-container>
        <v-row>
          <v-col
            cols="12"
            class="py-0 text-uppercase"
            :class="$store.state.mobile ? '' : 'mt-4'"
          >
            <v-row
              no-gutters
              align="center"
            >
              <v-col
                cols="auto"
                class="text-h1 font-medium"
              >
                <template v-if="$store.getters.languageGetter === '1'">
                  مركز الأخبار
                </template>
                <template v-else>
                  News Center
                </template>
              </v-col>
              <v-spacer />
              <v-col cols="auto">
                <router-link
                  :to="{name: 'NewsList'}"
                  class="d-inline-flex align-center text-h6"
                >
                  <template v-if="$store.getters.languageGetter === '1'">
                    شاهد المزيد
                  </template>
                  <template v-else>
                    See More
                  </template> <v-icon small>
                    mdi-chevron-right
                  </v-icon>
                </router-link>
              </v-col>
            </v-row>
          </v-col>
          <v-col
            v-for="item in newsList.data.items.slice(0,4)"
            :key="item.id"
            :cols="$store.state.mobile ? 6 : 3"
          >
            <v-card
              :outlined="$store.state.mobile"
              elevation="0"
              tile
            >
              <router-link
                :to="{name: 'NewsDetail', params: {id: item.id}}"
              >
                <v-img
                  aspect-ratio="1.5"
                  contain
                  :src="item.image + '?x-oss-process=image/resize,m_mfit,w_375,h_375'"
                  class="white"
                >
                  <template v-slot:placeholder>
                    <v-row
                      class="fill-height ma-0"
                      align="center"
                      justify="center"
                    >
                      <v-progress-circular
                        indeterminate
                        color="grey lighten-3"
                      />
                    </v-row>
                  </template>
                </v-img>
              </router-link>
            </v-card>
            <div class="text-h5 mt-3 text-truncate line-height-sm font-weight-bold">
              <router-link
                :to="{name: 'GoodsDetail', params: {id: item.id}}"
              >
                {{ $store.getters.languageGetter === '1' ? item.dnames : item.dnamesEn }}
              </router-link>
            </div>
            <div class="mt-2 line-break">
              {{ $store.getters.languageGetter === '1' ? item.summary : item.summaryEn }}
            </div>
            <div class="mt-2">
              {{ item.createTime | dateTruncate(10) }}
            </div>
          </v-col>
        </v-row>
      </v-container>
    </div>
    <news-letter />
  </div>
</template>

<script>
import NewsLetter from '@/layout/NewsLetter.vue';
import { mapActions, mapGetters, mapState } from 'vuex';
import { dateTruncate } from '@/plugins/filters';

export default {
  name: 'Home',
  filters: {
    dateTruncate,
  },
  components: {
    NewsLetter,
  },
  data() {
    return {
      swipeCarousel: 0,
      cateCarousel: 0,
    };
  },
  computed: {
    ...mapState(['tagGoods', 'adList', 'bannerList', 'newsList']),
    ...mapGetters(['categoriesPublished']),
    categoriesLocal() {
      const { length } = this.categoriesPublished;
      const arr = [];
      const step = this.$store.state.mobile ? 2 : 4;
      for (let i = 0; i < length; i += step) {
        arr.push(this.categoriesPublished.slice(i, i + step));
      }
      return arr;
    },
  },
  created() {
    this.loadPageData();
  },
  methods: {
    ...mapActions(['getGoodsByTagAsync', 'getAdListAsync', 'getBannerListAsync', 'getNewsListAsync']),
    loadPageData() {
      const promises = [
        this.getGoodsByTagAsync({
          type: '2', p: 1, name: 'newArrivals',
        }),
        this.getAdListAsync(),
        this.getBannerListAsync(),
        this.getNewsListAsync({ p: 1 }),
      ];
      Promise.all(promises);
    },
    navigateToGoodsList(item) {
      this.$store.commit('goods/RESET_GOODS_LIST');
      this.$router.push({
        name: 'GoodsList',
        query: {
          categoryId: item.id,
          categoryName: item.dnames,
          categoryNameEn: item.dnamesEn,
          p: 1,
        },
      });
    },
    priceRate(item) {
      return (+item.countryPrice[this.$store.getters.countryGetter.id] * +this.$store.getters.countryGetter.rate);
    },
  },
};
</script>

<style lang="scss" scoped>
.btn-prev,
.btn-next {
  position: absolute;
  z-index: 1;
  background-color: rgba($color: #000000, $alpha: 0.35);
}

.about-us {
  background-image: url('../assets/img-about-us-home.png');
  background-repeat: no-repeat;
}
</style>
